import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { ChartTooltip } from './ChartTooltip';

// Word-wrap a string into lines of at most `maxChars` characters (never truncates).
const wrap = (text, maxChars) => {
  if (text === null || text === undefined || text === '') return [];
  const words = String(text).split(/\s+/);
  const lines = [];
  let cur = '';
  for (const w of words) {
    const t = cur ? `${cur} ${w}` : w;
    if (t.length > maxChars && cur) { lines.push(cur); cur = w; }
    else cur = t;
  }
  if (cur) lines.push(cur);
  return lines;
};

// Multi-line X-axis tick: bold code on top + small canal · région sub-lines below.
// Everything wraps — nothing is ever truncated.
const makeXTick = (subLabels, tickFormatter) => (props) => {
  const { x, y, payload } = props;
  const main = tickFormatter ? tickFormatter(payload.value) : payload.value;
  const subLines = wrap(subLabels?.[payload.value] || '', 16);
  const lh = 11;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={12} textAnchor="middle"
        style={{ fontSize: 11, fontWeight: 600, fill: 'hsl(var(--foreground))' }}>{main}</text>
      {subLines.map((l, i) => (
        <text key={i} x={0} y={0} dy={12 + lh * (i + 1)} textAnchor="middle"
          style={{ fontSize: 9, fill: 'hsl(var(--muted-foreground))' }}>{l}</text>
      ))}
    </g>
  );
};

export const ComparisonBars = ({ data = [], series = [], height = 300, xKey = 'period', formatTip, xTickFormatter, subLabels }) => {
  const hasSub = !!(subLabels && Object.keys(subLabels).length);
  const xTick = hasSub ? makeXTick(subLabels, xTickFormatter) : undefined;
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%" minWidth={0}>
        <BarChart data={data} margin={{ top: 8, right: hasSub ? 16 : 8, bottom: hasSub ? 14 : 0, left: -8 }} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(11,19,32,0.06)" vertical={false} />
          <XAxis dataKey={xKey} tickLine={false} axisLine={false}
            tick={xTick} tickFormatter={hasSub ? undefined : xTickFormatter}
            height={hasSub ? 60 : undefined} interval={hasSub ? 'preserveStartEnd' : undefined}
            minTickGap={hasSub ? 24 : 16} padding={hasSub ? { left: 16, right: 44 } : undefined} />
          <YAxis tickLine={false} axisLine={false} width={44} />
          <Tooltip cursor={{ fill: 'rgba(11,19,32,0.04)' }} content={<ChartTooltip formatter={formatTip} />} />
          {series.length > 1 && <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />}
          {series.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} radius={[6, 6, 0, 0]} maxBarSize={28} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
